import { render, staticRenderFns } from "./AccidentsIncidentsContent.vue?vue&type=template&id=1bd34a99&scoped=true"
import script from "./AccidentsIncidentsContent.vue?vue&type=script&lang=js"
export * from "./AccidentsIncidentsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd34a99",
  null
  
)

export default component.exports